(function () {
  Flint.file('views/pages/notFoundPage.js', function (require) {
    Flint.staticStyles('NotFoundPage', {
      '$page': '#_flintapp page.NotFoundPage, #_flintapp .NotFoundPage.page, #_flintapp .ViewNotFoundPage.page, #_flintapp .NotFoundPage > .page',
      '$notFound': '#_flintapp notFound.NotFoundPage, #_flintapp .NotFoundPage.notFound, #_flintapp .ViewNotFoundPage.notFound, #_flintapp .NotFoundPage > .notFound'
    }, {
      '$page': {
        alignSelf: 'stretch'
      },
      '$notFound': {
        alignSelf: 'stretch',
        padding: [20, 0],

        borderBottom: '1px solid #ddd',
        fontSize: 24
      }
    });
    Flint.view('NotFoundPage', function (view, on, $) {
      var context = initContext(view, {
        isMobile: atom()
      });

      var pro = initPro(view, {});view.render(function () {
        return view.el(['NavBar', 1], null);
      });view.render(function () {
        return view.el(
          ['page', 1],
          null,
          view.el(
            ['notFound', 1],
            null,
            'Page not found.'
          )
        );
      });view.render(function () {
        return view.el(['Footer', 1], null);
      });

      $["page"] = function (_, _index) {
        return { padding: [20, 20, context.isMobile.get() ? 0 : 60]
        };
      };

      $["notFound"] = function (_, _index) {
        return { borderTop: context.isMobile.get() ? 'none' : '1px solid #ddd' };
      };
    });
  })
})();
//# sourceMappingURL=notFoundPage.js.map
